import React from 'react';

import { Routes } from 'react-router-dom';

import Layout from 'components/layout';

import { AUTH_ROUTES } from 'constants/routes';

import { renderRoutes } from 'utils/routes';

import s from './AppContent.module.scss';

const AppContent = () => {
  return (
    <Layout className={s.wrapper}>
      <Routes>{AUTH_ROUTES.map(renderRoutes)}</Routes>
    </Layout>
  );
};

export default AppContent;
